import React, { useState } from 'react';
import { Pressable, Text, StyleSheet, ActivityIndicator, Platform, ViewStyle, TextStyle, StyleProp } from 'react-native';
import { COLORS, APP_CONSTANTS } from '@/constants/residents';

type Props = {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  // Allow hover handlers to be passed through when needed (web)
  onHoverIn?: () => void;
  onHoverOut?: () => void;
};

export const PrimaryButton: React.FC<Props> = ({ title, onPress, disabled, loading, style, textStyle, onHoverIn, onHoverOut }) => {
  const [isHovered, setIsHovered] = useState(false);
  const hoverStyle = Platform.OS === 'web' && isHovered && !disabled ? styles.hover : null;

  return (
    <Pressable
      style={[styles.button, hoverStyle, style as any, disabled && styles.disabled]}
      onPress={onPress}
      disabled={disabled}
      onHoverIn={() => { setIsHovered(true); onHoverIn?.(); }}
      onHoverOut={() => { setIsHovered(false); onHoverOut?.(); }}
    >
      {loading ? (
        <ActivityIndicator color="#FFFFFF" />
      ) : (
        <Text style={[styles.text, textStyle as any]}>{title}</Text>
      )}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    height: APP_CONSTANTS.TEXT_FIELD_HEIGHT,
    backgroundColor: COLORS.BUTTON_PRIMARY,
    borderRadius: APP_CONSTANTS.BUTTON_CORNER_RADIUS,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 8,
    ...Platform.select({ web: { cursor: 'pointer' as any } }),
  },
  text: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
    fontFamily: Platform.select({
      ios: 'Avenir-Medium',
      android: 'sans-serif-medium',
      default: 'System',
    }),
  },
  disabled: {
    backgroundColor: '#6B7280',
    opacity: 0.6,
  },
  hover: {
    opacity: 0.85,
  },
});


